import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import React, { useEffect } from 'react'

import { fetchOfferBasedRecommendations } from 'actions/RecommendationActions'
import Heading from 'LuxKit/Typography/Heading'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import { getGraphRecommendations } from 'selectors/recomendations/graphSelectors'
import styled from 'styled-components'
import ExpiredDealsHeroOffers from './ExpiredDealsHeroOffers'
import useIdleTimeReporter, { IdleTimeSource } from '../hooks/useIdleTimeReporter'
import ExpiredDealsOfferPill from './ExpiredDealsOfferPill'
import { take } from 'lib/array/arrayUtils'
import { useIntl } from 'react-intl'

const Background = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding-top: ${rem(20)};
`

const RootLayout = styled.div`
 background-color: ${props => props.theme.palette.neutral.default.eight};
`

interface Props {
  offer: App.Offer
}

function ExpiredDealsHero(props: Props) {
  const { offer } = props
  const intl = useIntl()
  const dispatch = useAppDispatch()

  useIdleTimeReporter(IdleTimeSource.ExpiredDeals)

  useEffect(() => {
    dispatch(fetchOfferBasedRecommendations(offer.id, false))
  }, [dispatch, offer.id])

  const offersSimilarToTopOffer = useAppSelector<App.OfferBasedGraphRecommendation>(state => getGraphRecommendations(state, offer.id))
  const similarOffersLoading = offersSimilarToTopOffer.state === 'loading'
  const title = offer.property
    ? intl.formatMessage(
        {
          id: 'FoP6wMVnW1',
          defaultMessage: 'Offers similar to {hotelName}',
          description: 'Title for offers similar to a specific hotel',
        },
        { hotelName: offer.property.name },
      )
    : intl.formatMessage({
        id: 'CFqtXcymWO',
        defaultMessage: 'Similar offers',
        description: 'Title for similar offers section',
      })
  const offerIds = take(offersSimilarToTopOffer.offerIds, 6)
  return (
    <Background>
      <RootLayout>
        <ExpiredDealsOfferPill offer={offer} />
        <ExpiredDealsHeroOffers
          heading={<Heading variant="heading5">{title}</Heading>}
          offerIds={offerIds}
          fetching={similarOffersLoading}
          trackingPageSource={offer.type}
          trackingUiTouchPoint="Expired Deals Header V2.0.1"
        />
      </RootLayout>
    </Background>
  )
}

export default withOfferPageAndReduxState((state) => {
  return {
    offer: state.offer,
  }
}, ExpiredDealsHero)
